export const CHAT_HOVER_DRAG_MOUSE_THRESHOLD = 5;
export const CHAT_HOVER_DRAG_TOUCH_THRESHOLD = 8;

const finiteNumber = (value, fallback = 0) => {
  const numberValue = Number(value);
  return Number.isFinite(numberValue) ? numberValue : fallback;
};

export const getChatHoverDragThreshold = (pointerType) =>
  pointerType === "touch"
    ? CHAT_HOVER_DRAG_TOUCH_THRESHOLD
    : CHAT_HOVER_DRAG_MOUSE_THRESHOLD;

export const getChatHoverDragBounds = ({
  viewportWidth,
  panelWidth,
  viewMargin = 0,
}) => {
  const safeViewportWidth = Math.max(0, finiteNumber(viewportWidth));
  const safePanelWidth = Math.max(0, finiteNumber(panelWidth));
  const safeViewMargin = Math.max(0, finiteNumber(viewMargin));

  if (safeViewportWidth <= 0 || safePanelWidth <= 0) {
    return { minX: 0, maxX: 0 };
  }

  const maxX = safeViewMargin;
  const minX = Math.min(
    maxX,
    safePanelWidth + safeViewMargin - safeViewportWidth,
  );

  return { minX, maxX };
};

export const clampChatHoverTranslateX = (value, bounds) => {
  const minX = Math.min(
    finiteNumber(bounds?.minX),
    finiteNumber(bounds?.maxX),
  );
  const maxX = Math.max(
    finiteNumber(bounds?.minX),
    finiteNumber(bounds?.maxX),
  );

  return Math.min(maxX, Math.max(minX, finiteNumber(value)));
};

export const shouldActivateChatHoverDrag = ({
  deltaX,
  deltaY = 0,
  threshold = CHAT_HOVER_DRAG_MOUSE_THRESHOLD,
}) => {
  const absX = Math.abs(finiteNumber(deltaX));
  const absY = Math.abs(finiteNumber(deltaY));
  const safeThreshold = Math.max(0, finiteNumber(threshold));

  return absX >= safeThreshold && absX >= absY;
};

export const getChatHoverDragTranslateX = ({
  startTranslateX,
  startClientX,
  clientX,
  bounds,
}) =>
  clampChatHoverTranslateX(
    finiteNumber(startTranslateX) +
      finiteNumber(clientX) -
      finiteNumber(startClientX),
    bounds,
  );
